D.Analytics = {

	branch( event, par, data = null ) {
		if( D.DEV || typeof window.branch === 'undefined' ) {
			return;
		}
		window.branch.logEvent(event, par, data);
	},

	ga( par, type = 'send' ) {
		if( D.DEV || typeof window.ga === 'undefined' ) {
			return;
		}
		window.ga(type, par);
	},

	klaviyo( event, par, type = 'track' ) {
		if( D.DEV || typeof window._learnq === 'undefined' ) {
			return;
		}
		window._learnq.push([type, event, par]);
	},

	fbq( event, par = null, type = 'track' ) {
		if( D.DEV ) {
			return;
		}
		if( typeof window.fbq !== "undefined" ) {
			window.fbq(type, event, par);
			// If fbq isn't set, then marketing probably not allowed
			if( type === 'track' ) {
				this.cApi(event, par);
			}
		}
	},

	cApi( event, data = null ) {
		const formData = new FormData();
		formData.append('event', event);
		if( data !== null ) {
			formData.append('data', JSON.stringify(data));
		}
		const r = new XMLHttpRequest;
		r.open('POST', '/capi.php', true);
		r.send(formData);
	}

}